// extracted by mini-css-extract-plugin
export default {"borderGrey":"#b5b4b5","zIndexModalBackdrop":"1040","container":"GJg4cQ5YIOyJxafL","error":"kfOk_giw9sKjUP3R","info":"h8l5g0VAbjiK3EyU"};